import React from 'react';

import { classnames } from '../../../utils/classnames';

import './status.css';

export function Status({ color, text }) {
	return (
		<div className={classnames('wz-neo-status', color)}>
			{text}
		</div>
	);
}
